import { get, post, patch } from "../config/user-api";

export const PaymentAccount = {
  getAll: () => get(`/payment-account`),
  getById: (id: string) => get(`/payment-account/${id}`),
  create: (data: any) => post(`/payment-account`, data),
  update: (id: string, data: any) => patch(`/payment-account/${id}`, data),
};
